export default __webpack_public_path__ + "img/byqwPCZM.99cfccec.svg";